<div class="contacts-custom-list-view">
  <header [options]="headerOptions"></header>

  <tui-scrollbar class="list-wrapper">
    <div>
      <ng-container *ngFor="let item of listItems">
        <list-item-view
          [itemTitle]="item.title"
          [clickable]="isParent"
          (removeItem)="onClickDeleteButton(item)"
          (click)="selectDirectory.emit(item)"
        ></list-item-view>

        <div class="separator"></div>
      </ng-container>
    </div>
  </tui-scrollbar>
</div>
